// Share-link parameters SignInModal prefills itself from: `to_email` (the address the
// packet was shared with) and `sharer_id` (who shared it, carried onto the sign-in
// Mixpanel events for attribution).
//
// They are consumed destructively — read off the URL and deleted so a reload or a copied
// link doesn't carry them — which made the read a race while more than one modal was
// mounted: useSearchParams hands every instance the SAME mutable URLSearchParams, so the
// first effect to run took the values and the rest saw nothing. Capturing into a module
// cache decouples "who deletes them" from "who gets them": whichever instance reads
// first, every instance can still ask for the values afterwards.
let captured = { email: '', sharerId: '' };

/**
 * Take `to_email` / `sharer_id` off `searchParams` (mutating it) and remember them.
 * @returns {{email: string, sharerId: string, edited: boolean}} the newly captured values
 *   (empty when the URL had none) and whether searchParams was modified.
 */
export const consumeSignInPrefill = (searchParams) => {
  const email = searchParams.get('to_email') || '';
  const sharerId = searchParams.get('sharer_id') || '';

  if (email) searchParams.delete('to_email');
  if (sharerId) searchParams.delete('sharer_id');
  if (email || sharerId) {
    captured = { email: email || captured.email, sharerId: sharerId || captured.sharerId };
  }

  return { email, sharerId, edited: Boolean(email || sharerId) };
};

/** What a modal should start from when it opens: the last captured share-link values. */
export const getSignInPrefill = () => captured;

export const resetSignInPrefillForTest = () => {
  captured = { email: '', sharerId: '' };
};
